import { render, staticRenderFns } from "./DownloadRecord.vue?vue&type=template&id=6fd87318&scoped=true"
import script from "./DownloadRecord.vue?vue&type=script&lang=js"
export * from "./DownloadRecord.vue?vue&type=script&lang=js"
import style0 from "./DownloadRecord.vue?vue&type=style&index=0&id=6fd87318&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd87318",
  null
  
)

export default component.exports